<template>
	<modal name="brandCarNamePopup" :width="850" :height="550" :clickToClose="false" @opened="opened">
		<div class="popup on" id="menu_pop10" style="left: 535px; top: 207.5px; display: block;">
			<div class="pop_tit">브랜드 / 차량명 조회</div>
			<div class="scroll_area pop_con_wrap mCustomScrollbar _mCS_11 mCS_no_scrollbar" style="height:400px;">
				<div id="mCSB_11" class="mCustomScrollBox mCS-dark-thick mCSB_vertical mCSB_inside" tabindex="0" style="max-height: none;">
					<div id="mCSB_11_container" class="mCSB_container mCS_y_hidden mCS_no_scrollbar_y" style="position:relative; top:0; left:0;" dir="ltr">
						<div class="pop_search_bg">
							<div class="board_list type02">
								<div class="ins_search_wrap">
									<div class="ins_search">
										<div class="board_list type02">
											<grid :options="brandList_grid" v-once />
										</div>
									</div>
									<div class="ins_search">
										<div class="board_list type02">
											<grid :options="carNameList_grid" v-once />
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div id="mCSB_11_scrollbar_vertical" class="mCSB_scrollTools mCSB_11_scrollbar mCS-dark-thick mCSB_scrollTools_vertical" style="display: none;">
						<div class="mCSB_draggerContainer">
							<div id="mCSB_11_dragger_vertical" class="mCSB_dragger" style="position: absolute; min-height: 30px; top: 0px; height: 0px;">
								<div class="mCSB_dragger_bar" style="line-height: 30px;">
								</div>
							</div>
							<div class="mCSB_draggerRail">
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="pop_footer_wrap">
				<div class="btn_area mt0">
					<a href="javascript:void(0);" class="button dark" @click="close"><span>닫기</span></a>
					<a href="javascript:void(0);" class="button blue" @click="chosen"><span>확인</span></a>
				</div>
			</div>
			<a href="javascript:void(0);" class="pop_close" title="close" @click="close">close</a>
		</div>
	</modal>
</template>

<script>
import Vue from 'vue'
import Grid from '@/components/Grid'
import GridModule from '@/modules/grid'

export default {
	name: 'BrandCarNamePopup',
	components: { Grid },
	props: {
		value: ''
	},
	data() {
		return {
			brandCarName: '선택된 브랜드/차량명',
			brandList_grid: {
				general: {
					id: 'brandList-grid',
					search: '/brand/list',
					type: {
						isUpdate : false,
						isHideAdd : true,
						isHideUpdate : true,
						isHideDel: true,
						isHideReset: true
					},
					PageInfo: {

					},
					params: {
						insuranceChargerName: ''
					},
					excel: false
				},
				grid_options: {
					height: '10row',
          fitTableWidth: true,
					rowSelectOption: {
						clickSelect: true,
						singleSelect: true,
						disableSelectByKey: true
					},
					paging:{
						pagerTotal:false
					},
					columnMapping: [// 컬럼 미정
						{key: 'id', hidden: true},
						{key: 'check', 							title: '선택',		width: '55px',	selectorColumn : true},
						{key: 'brandName', 					title: '브랜드',	width: '314px',	align: 'center'}
					]
				}
			},
			carNameList_grid: {
				general: {
					id: 'carNameList-grid',
					search: '',
					type: {
						isDataShow: false,
						isUpdate : false,
						isHideAdd : true,
						isHideUpdate : true,
						isHideDel: true,
						isHideReset: true
					},
					PageInfo: {

					},
					params: {
						brandName: ''
					},
					excel: false
				},
				grid_options: {
					height: '10row',
          fitTableWidth: true,
					rowSelectOption: {
						clickSelect: true,
						singleSelect: true,
						disableSelectByKey: true
					},
					paging:{
						pagerTotal:false
					},
					alwaysShowHorizontalScrollBar: false,
					columnMapping: [// 컬럼 미정
						{key: 'id', hidden: true},
						{key: 'check',		title: '선택',		width: '55px',	selectorColumn : true},
						{key: 'carName',	title: '차량명',	width: '314px',	align: 'center'}
					]
				}
			}
		}
	},
	methods: {
		opened() {
			$('#brandList-grid').on('click',this.clickBrandListGrid);
      // close 버튼 표시를 위해 반드시 필요
      $("#menu_pop10").parent().css('overflow', 'visible');  
      //팝업창 스크롤바 css 컨트롤(공통)
      $("#scroll_area").mCustomScrollbar( {
        theme: "dark-thick",
        scrollInertia: 500
      });
		},
    close() {
      this.$modal.hide('brandCarNamePopup');
		},
		chosen() {// 확인
			//barndList, CarList에서 선택된 행의 데이터에서 "브랜드명,차량명"로 담아 반환
			/*
			var brnadData = $('#brandList-grid').alopexGrid('dataGet', {_state: {edited:true}}, {_state:{selected:true}});
			var carData = $('#carNameList-grid').alopexGrid('dataGet', {_state: {edited:true}}, {_state:{selected:true}});
			if ((brnadData.data.aaa != null && brnadData.data.aaa != '') 
				|| (carData.data.aaa != null && evObj.carData.aaa != '')) {
				this.brandCarName = brnadData.data.aaa + ',' + carData.data.aaa;
			}

*/
			if (this.brandCarName == null || this.brandCarName == undefined
				|| this.brandCarName == '' || this.brandCarName == '선택된 브랜드/차량명') {
					Vue.Alert.alert('선택된 브랜드/차량명이 없습니다.'); 
					return false;
			}
			this.$emit('brandCarNamePopup',this.brandCarName);
			this.$modal.hide('brandCarNamePopup');
		},
		clickBrandListGrid(e) {
			// 브랜드 선택시 차량명 조회
			var evObj = AlopexGrid.parseEvent(e);
			console.log(evObj)
			/*if (evObj.data.aaa != null && evObj.data.aaa != '') {
				this.carNameList_grid.general.params.brandName = '' // 브랜드명
				GridModule.searchData(this.carNameList_grid);
			}*/
		}
	}
	
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/common/BrandCarNamePopup.vue